<script setup lang="ts">
  import { provide } from 'vue'
  import { estimatedTimeNamesKey } from '@gat-ship/types/injection-keys'
  import { useEstimatedTimeNamesDataSource } from '../../../composables/useEstimatedTimeNamesDataSource'

  const props = withDefaults(
    defineProps<{
      /** Fetch the registry once when the provider mounts. */
      fetchOnMount?: boolean
    }>(),
    { fetchOnMount: true }
  )

  const service = useEstimatedTimeNamesDataSource()

  if (props.fetchOnMount) {
    void service.fetch()
  }

  provide(estimatedTimeNamesKey, service)
  defineExpose(service)
</script>

<template>
  <slot />
</template>
